// @flow
import { QuestionSurveysActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    questionSurvey: {},
    listaQuestionSurveys: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type QuestionSurveysAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { questionSurvey?: {} | null, listaQuestionSurveys?: [] | null, loading?: boolean, +value ?: boolean };

const QuestionSurveys = (state: State = INIT_STATE, action: QuestionSurveysAction): any => {
    // console.log(action);
    switch (action.type) {
        case QuestionSurveysActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case QuestionSurveysActionTypes.GET_QUESTION_SURVEY: {
                    return {
                        ...state,
                        questionSurvey: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case QuestionSurveysActionTypes.LIST_QUESTION_SURVEYS: {
                    return {
                        ...state,
                        listaQuestionSurveys: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case QuestionSurveysActionTypes.ADD_QUESTION_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionSurveysActionTypes.UPDATE_QUESTION_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionSurveysActionTypes.DELETE_QUESTION_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case QuestionSurveysActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case QuestionSurveysActionTypes.GET_QUESTION_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        questionSurvey: {},
                        loading: false,
                    };
                }
                case QuestionSurveysActionTypes.LIST_QUESTION_SURVEYS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaQuestionSurveys: [],
                        loading: false,
                    };
                }
                case QuestionSurveysActionTypes.ADD_QUESTION_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionSurveysActionTypes.UPDATE_QUESTION_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case QuestionSurveysActionTypes.DELETE_QUESTION_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case QuestionSurveysActionTypes.GET_QUESTION_SURVEY:
            return { ...state, error: false, loading: true };
        case QuestionSurveysActionTypes.LIST_QUESTION_SURVEYS:
            return { ...state, error: false, loading: true };
        case QuestionSurveysActionTypes.ADD_QUESTION_SURVEY:
            return { ...state, error: false, loadingForm: true };
        case QuestionSurveysActionTypes.UPDATE_QUESTION_SURVEY:
            return { ...state, error: false, loadingForm: true };
        case QuestionSurveysActionTypes.DELETE_QUESTION_SURVEY:
            return { ...state, error: false, loading: true };
        case QuestionSurveysActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                questionSurvey: {},
                listaQuestionSurveys: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default QuestionSurveys;
